import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={16.015}
    height="6.8mm"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 6511 10449"
    {...props}
  >
    <path
      d="M3619 9214V5518c854-36 1829-166 2892-461L4655 0H1855L0 5057s1099 433 2891 469v3688c-959 31-1687 183-1687 366v587s2182 634 4103 0v-587c0-183-728-335-1688-366z"
      style={{
        fill: "#231f20",
      }}
      className="fill"
    />
  </svg>
)
export default SvgComponent
